import React, { useEffect, useState } from 'react'
import { Box, Button, LinearProgress, Stack, TextField, Typography } from '@mui/material'
import API from '../../../services/API'

const EmployeeSectionForm = ({ appraisal, onSaved }) => {
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [answers, setAnswers] = useState([])

  useEffect(() => {
    API.get('/settings?select=staffAppraisalSettings').then((res) => {
      if (res.status === 200) {
        const questions =
          res.data?.staffAppraisalSettings?.appraisalQuestions ?? []
        setAnswers(
          questions
            .filter((q) => q.section === 'employee')
            .map((q) => ({ key: q.key, question: q.prompt, answer: '' })),
        )
      }
      setLoading(false)
    })
  }, [])

  const handleAnswerChange = (index, answer) => {
    setAnswers((prev) =>
      prev.map((item, idx) => (idx === index ? { ...item, answer } : item)),
    )
  }

  const allAnswered = answers.every((item) => item.answer?.trim())

  const handleSubmit = () => {
    setSaving(true)
    API.put(`/appraisals/${appraisal._id}/employee-section`, { answers })
      .then((res) => {
        if (res.status === 200) {
          onSaved(res.data)
        }
      })
      .finally(() => setSaving(false))
  }

  if (loading) return <LinearProgress />

  return (
    <Stack gap={3}>
      {answers.map((item, i) => (
        <Box key={item.key}>
          <Typography sx={{ color: '#242F40', fontWeight: 500, mb: 1 }}>
            {item.question}
          </Typography>
          <TextField
            value={item.answer}
            onChange={(e) => handleAnswerChange(i, e.target.value)}
            multiline
            minRows={3}
            fullWidth
          />
        </Box>
      ))}

      <Button
        variant="contained"
        size="large"
        onClick={handleSubmit}
        disabled={saving || !allAnswered}
      >
        Submit for HR Review
      </Button>
    </Stack>
  )
}

export default EmployeeSectionForm
